import { render, staticRenderFns } from "./Computer.vue?vue&type=template&id=7312cdec&scoped=true&"
import script from "./Computer.vue?vue&type=script&lang=js&"
export * from "./Computer.vue?vue&type=script&lang=js&"
import style0 from "./Computer.vue?vue&type=style&index=0&id=7312cdec&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312cdec",
  null
  
)

export default component.exports